//import PerfectScrollbar from 'perfect-scrollbar';
import { Dropdown } from 'bootstrap';

jQuery(document).ready(function ($) {

  $('#main-menu .menu-item-has-children').on('mouseover', function () {
    Dropdown.getOrCreateInstance($(this).children('.dropdown-toggle')[0]).show();
  });

  $('#main-menu .menu-item-has-children').on('mouseout', function () {
    Dropdown.getOrCreateInstance($(this).children('.dropdown-toggle')[0]).hide();
  });

  //close btn navigation
  $('.navbar-header .sec-navbar .close-btn').on('click', function () {
    $('.navbar-header .sec-navbar > .close-btn').hide();
    $('.navbar-header #navbarMobile').addClass('closing');
    setTimeout(function () {
      $('.navbar-header #navbarMobile').removeClass('closing');
    }, 1000);
  });

  $('.navbar-header .sec-navbar .toggle-nav').on('click', function () {
    $('.navbar-header .sec-navbar > .close-btn').show();
  });

  var $navbarAnchor = '';
  var $navbarHeight = '';
  var $navbarWidth = '';

  //anchor menu
  if ($('.js-anchor-menu').length > 0) {
    var anchorArray = {};
    var i = 1;

    $navbarAnchor = $('.js-anchor-menu');
    var stickyNavAnchorTop = $navbarAnchor.offset().top;
    var navbarOffset = $('.js-navbar').height() + 30;



    //get all the blocks with anchor
    $('#main .entry-content > div').each(function () {
      var attr = $(this).attr('data-anchor');
      if (typeof attr !== typeof undefined && attr !== false) {
        anchorArray[i] = {
          id: $(this).attr('id'),
          title: $(this).attr('data-anchor')
        }
        i++;
      }
    });

    //create menu items
    $.each(anchorArray, function (key, anchor) {
      $navbarAnchor.find('#anchor-submenu').append('<li><a href="#' + anchor['id'] + '">' + anchor['title'] + '</a></li>');
    });

    $navbarHeight = $navbarAnchor.height();

    //resize menu
    var resizeAnchorNav = function () {
      var scrollTop = $(window).scrollTop() + navbarOffset;
      $navbarWidth = $navbarAnchor.parent('.intro-menu').width();

      if (scrollTop > stickyNavAnchorTop) {
        $navbarAnchor.css('width', $navbarWidth + 'px');
        $navbarAnchor.parent('.intro-menu').css('height', $navbarHeight + 'px');
      } else {
        $navbarAnchor.css('width', '100%');
        $navbarAnchor.parent('.intro-menu').css('height', 'auto');
      }
    };

    //make sticky
    var stickyAnchorNav = function () {

      var scrollTop = $(window).scrollTop() + navbarOffset;
      if (scrollTop > stickyNavAnchorTop) {
        $navbarAnchor.addClass('sticky');
        $navbarAnchor.css('top', navbarOffset + 'px');
      } else {
        $navbarAnchor.removeClass('sticky');
      }
    };
    resizeAnchorNav();
    stickyAnchorNav();
    $(window).scroll(function () {
      resizeAnchorNav();
      stickyAnchorNav();
    });

    $(window).resize(function () {
      resizeAnchorNav();
    });
  }

  var $lastItem = '';

  //kennis anchor menu
  if ($('.js-dossier-anchor-menu').length > 0) {
    var anchorArray = {};
    var i = 1;
    $navbarAnchor = $('.js-dossier-anchor-menu');
    var stickyNavAnchorTop = $navbarAnchor.offset().top;
    var navbarOffset = $('.js-navbar').height() + 30;


    //get all the blocks with anchor
    $('#main .entry-content > div').each(function () {
      var attr = $(this).attr('data-anchor');
      if (typeof attr !== typeof undefined && attr !== false) {
        anchorArray[i] = {
          id: $(this).attr('id'),
          title: $(this).attr('data-anchor')
        }
        i++;
      }
    });

    //create menu items
    $.each(anchorArray, function (key, anchor) {
      $navbarAnchor.find('ul.anchor-menu').append('<li data-anchor="' + anchor['id'] + '"><a href="#' + anchor['id'] + '">' + anchor['title'] + '</a></li>');
    });


    //reposition menu
    var repositionAnchorNav = function () {
      var scrollTop = $(window).scrollTop() + navbarOffset;
      var menuMarginTop = $navbarAnchor.find('ul.anchor-menu').offset().top;

      $.each(anchorArray, function (key, anchor) {
        //half way the screen, make active
        var halfWinHeight = $(window).height() / 2;
        var anchorTop = $('#' + anchor['id']).offset().top - halfWinHeight;
        $navbarAnchor.find('ul.anchor-menu li[data-anchor="' + anchor['id'] + '"]').removeClass('active');
        if (scrollTop > anchorTop) {
          $lastItem = anchor['id'];
        }

      });

      if ($lastItem !== '') {
        var menuMargin = menuMarginTop - $navbarAnchor.find('ul.anchor-menu li[data-anchor="' + $lastItem + '"]').offset().top;
        $navbarAnchor.find('ul.anchor-menu').css('margin-top', menuMargin + 'px');
        $navbarAnchor.find('ul.anchor-menu li[data-anchor="' + $lastItem + '"]').addClass('active');
      }

    };


    //resize menu
    var resizeAnchorNav = function () {
      var scrollTop = $(window).scrollTop() + navbarOffset;
      $navbarWidth = $navbarAnchor.width();

      var defaultWidth = 125;
      var availableWidth = $('.container').offset().left - 15; //15 is the margin left

      if (availableWidth > defaultWidth) {
        $navbarAnchor.css('width', availableWidth + 'px');
        $navbarAnchor.removeClass('has-bg');
      } else {
        $navbarAnchor.css('width', 'auto');
        $navbarAnchor.addClass('has-bg');
      }
    };

    //make sticky
    var stickyAnchorNav = function () {

      var headerHeight = $(window).width() / 4;
      var scrollTop = $(window).scrollTop();
      var navbarOffset = $('.js-navbar').height() + 30;
      var footerOffset = $('#wrapper-footer').offset().top;
      var menuHeight = $navbarAnchor.find('.anchor-menu').height();

      var startPos = navbarOffset + headerHeight + 56; //menu + header + margin

      var stickyPos = navbarOffset + menuHeight;
      var stickyEndPos = footerOffset - menuHeight + 80;
      var scrollTrigger = scrollTop + navbarOffset + menuHeight;

      if (scrollTrigger > stickyEndPos) {
        //footer stop
        $navbarAnchor.removeClass('sticky');
        $navbarAnchor.css('top', stickyEndPos + 'px');
      } else {
        if (scrollTrigger > startPos) {
          $navbarAnchor.addClass('sticky');
          $navbarAnchor.css('top', stickyPos + 'px');
        } else {
          $navbarAnchor.removeClass('sticky');
          $navbarAnchor.css('top', startPos + 'px');
        }
      }
    };

    stickyAnchorNav();
    resizeAnchorNav();
    repositionAnchorNav();
    $(window).scroll(function () {
      stickyAnchorNav();
      resizeAnchorNav();
      repositionAnchorNav();
    });

    $(window).resize(function () {
      stickyAnchorNav();
      resizeAnchorNav();
      repositionAnchorNav();
    });

  }

  //news intro sticky sidebar
  if ($('.js-intro-sidebar').length > 0) {


    var stickyIntro = $('.js-intro-sidebar');

    var navbarOffset = $('.js-navbar').height() + 30;
    var stickyWidth = $('.js-col').width() - 32; //minus padding
    var stickyIntroTop = stickyIntro.offset().top;

    var containerDiv = $('.block-nieuws-intro').offset().top + $('.block-nieuws-intro').height();

    var makeStickyIntro = function () {
      var scrollTop = $(window).scrollTop() + navbarOffset;
      //var stickyIntroParent = stickyIntroParent.parent();
      var stickyIntroBottom = scrollTop + stickyIntro.outerHeight();
      var stickyEndPos = $('.block-nieuws-intro').height() - stickyIntro.outerHeight() - 12;

      //menu on bottom of div
      if (stickyIntroBottom > containerDiv) {
        stickyIntro.removeClass('sticky');
        stickyIntro.css('top', stickyEndPos + 'px');

      } else {
        if (scrollTop > stickyIntroTop) {
          stickyIntro.css('width', stickyWidth + 'px');
          stickyIntro.addClass('sticky');
          stickyIntro.css('top', '');

        } else {
          stickyIntro.removeClass('sticky');
          stickyIntro.css('top', '');
        }
      }
    };
    makeStickyIntro();

    $(window).scroll(function () {
      makeStickyIntro();
    });
  }



  //search sticky sidebar
  if ($('.js-search-sidebar').length > 0) {

    var stickySidebar = $('.js-search-sidebar');

    var makestickySidebar = function () {
      //recalculated on every call: page height changes (ajax filtering,
      //collapsing filters, images loading) shift the navbar/sidebar/footer
      //positions, so caching these once at page load goes stale and lets
      //the fixed sidebar scroll past the footer.
      var navbarOffset = $('.js-navbar').height() + 30;
      var stickyWidth = $('.js-col').width();
      var startDiv = $('.js-col').offset().top;
      var stickySidebarTop = startDiv;
      var endDiv = $('#wrapper-footer').offset().top - 80;

      var scrollTop = $(window).scrollTop() + navbarOffset;
      var stickySidebarBottom = scrollTop + stickySidebar.outerHeight();
      var stickyEndPos = $('#wrapper-footer').offset().top - stickySidebar.outerHeight() - startDiv - 80;

      var resultWrapper = $('.result-col').height();

      if (resultWrapper > stickySidebar.height()) {
        stickySidebar.removeClass('relative');
        //menu on bottom of div
        if (stickySidebarBottom > endDiv) {
          stickySidebar.removeClass('sticky');
          stickySidebar.css('top', stickyEndPos + 'px');
        } else {
          if (scrollTop > stickySidebarTop) {
            stickySidebar.css('width', stickyWidth + 'px');
            stickySidebar.addClass('sticky');
            stickySidebar.css('top', navbarOffset + 'px');

          } else {
            stickySidebar.removeClass('sticky');
            stickySidebar.css('top', '');
          }
        }
      } else {
        stickySidebar.removeClass('sticky');
        stickySidebar.css('top', '');
        stickySidebar.addClass('relative');
      }
    };
    makestickySidebar();

    $(window).on('scroll', function () {
      makestickySidebar();
    });

    $(window).on('resize', function () {
      makestickySidebar();
    });

    //Search & Filter Pro fires this on document once ajax results are swapped in,
    //which changes the height of the page (and so the footer position) without a scroll/resize.
    $(document).on('sf:ajaxfinish', function () {
      makestickySidebar();
    });
  }

  //swiper slider
  if ($('.swiper-container').length > 0) {
    $('.swiper-container').each(function () {
      var block_id = $(this).parents('.block-logolist').attr('id');
      var swiper_id = $(this).attr('id');

      if ($(this).hasClass('logos')) {
        //logo list
        var swiperSlider = new Swiper('#' + swiper_id, {
          slidesPerView: 2,
          autoplay: 4000,
          speed: 500,
          navigation: {
            nextEl: '#' + block_id + ' .swiper-button-next',
            prevEl: '#' + block_id + ' .swiper-button-prev',
          },
          a11y: {
            prevSlideMessage: 'Vorige slide',
            nextSlideMessage: 'Volgende slide'
          },
          // Responsive breakpoints
          breakpoints: {
            768: {
              slidesPerView: 3
            },
            992: {
              slidesPerView: 4
            }
          }
        });
      } else if ($(this).hasClass('kennis-slider')) {

        var block_id = $(this).parents('.block-kennis').attr('id');

        if ($(this).hasClass('kennis-slider-big')) {

          var swiperSliderKennis = new Swiper('#' + swiper_id, {
            slidesPerView: 1,
            loop: false,
            autoplay: 4000,
            speed: 800,
            spaceBetween: 30,
            navigation: {
              nextEl: '#swiper-nav-' + block_id + ' .swiper-button-next',
              prevEl: '#swiper-nav-' + block_id + ' .swiper-button-prev',
            },

            a11y: {
              prevSlideMessage: 'Vorige slide',
              nextSlideMessage: 'Volgende slide'
            },       // Responsive breakpoints
            breakpoints: {
              600: {
                slidesPerView: 1
              },
              768: {
                slidesPerView: 1
              },
              1200: {
                slidesPerView: 1
              },
            }
          });

        } else {
          var swiperSliderKennis = new Swiper('#' + swiper_id, {
            slidesPerView: 1,
            loop: false,
            autoplay: 4000,
            speed: 500,
            spaceBetween: 30,
            observer: true,
            observeParents: true,
            watchOverflow: true,
            navigation: {
              nextEl: '#swiper-nav-' + block_id + ' .swiper-button-next',
              prevEl: '#swiper-nav-' + block_id + ' .swiper-button-prev',
            },
            a11y: {
              prevSlideMessage: 'Vorige slide',
              nextSlideMessage: 'Volgende slide'
            },
            breakpoints: {
              600: {
                slidesPerView: 1
              },
              768: {
                slidesPerView: 1
              },
              1200: {
                slidesPerView: 3
              },
            }
          });
        }
        swiperSliderKennis.on('slideChange', function (e) {
          if (swiperSliderKennis.activeIndex !== 0) {
            $('.js-dossier-anchor-menu').addClass('has-slide-bg');
          } else {
            $('.js-dossier-anchor-menu').removeClass('has-slide-bg');
          }
        });

      } else {
        //image slider - scope navigation to parent block to prevent conflicts
        var foto_block_id = $(this).parents('[id]').first().attr('id');
        var swiperSlider = new Swiper('#' + swiper_id, {
          autoplay: 4000,
          speed: 500,
          navigation: {
            nextEl: '#' + foto_block_id + ' .swiper-button-next',
            prevEl: '#' + foto_block_id + ' .swiper-button-prev',
          },
          a11y: {
            prevSlideMessage: 'Vorige slide',
            nextSlideMessage: 'Volgende slide'
          }
        });
      }
    });
  }




  if ($('.js-sidenotes').length > 0) {

    //position sidenotes
    repositionSidenotes();

    $('.js-article-content a[href^="#"]').on('mouseover', function (e) {
      var anchorId = $(this).attr('href');
      $(anchorId).addClass('active');
    });


    $('.js-article-content a[href^="#"]').on('mouseleave', function (e) {
      var anchorId = $(this).attr('href');
      $(anchorId).removeClass('active');
    });

    $('.js-article-content a[href^="#"]').each(function () {
      var anchorId = $(this).attr('href');
      var content = $(anchorId).find('.sidenote-content').html();
      $(this).after('<span class="sidenote-insert">' + content + '</span>');
    });

    $('.js-article-content a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      var anchorId = $(this).attr('href');

      if ($(window).width() < 992) {
        //mobile
        $(this).next('.sidenote-insert').toggleClass('show');

      } else {
        var extLink = $(anchorId).find('.sidenote-link').attr('href');

        if (extLink != null) {
          window.open(extLink, '_blank');
        }
      }

    });
  }

  $(window).on('resize', function () {
    if (jQuery('.js-sidenotes').length > 0) {
      repositionSidenotes();
    }
  });

  //S&F changes
  $('form.searchandfilter ul li.sf-field-reset .search-filter-reset').on('click', function () {
    $('form.searchandfilter ul li').each(function () {
      $(this).removeClass('active');
      var filterTitle = $(this).find('h4').text();
      if (filterTitle !== '') {
        $(this).find('h5').text(filterTitle);
      }
    });
  });

  //S&F jaar option
  if ($('form.searchandfilter ul li.sf-field-post-meta-tabel_jaar').length) {
    /*
    $jaarSelector = $('form.searchandfilter ul li.sf-field-post-meta-tabel_jaar');
  
    $('form.searchandfilter ul li.sf-field-post_type input').each(function(){
      if($(this).val() == 'project'){
        if($(this).parent('.sf-level-0').hasClass('sf-option-active')){
          $jaarSelector.show();
        }else{
          $jaarSelector.hide();
        }
      }
    });
    $('form.searchandfilter ul li.sf-field-post_type input[value="project"]').on('click', function(){
      if($(this).is(":checked")){
        $jaarSelector.show();
      }else{
        $jaarSelector.hide();
      }
    });
    */
  }

  //S&F Nieuws date - show selected value
  if ($('form.searchandfilter ul li.sf-field-post-meta-news_search_date').length) {
    $('form.searchandfilter ul li.sf-field-post-meta-news_search_date li').on('click', function () {
      var textLabel = $(this).find('label').text();
      $('form.searchandfilter ul li.sf-field-post-meta-news_search_date > h5').text(textLabel);
    });
  }

  //S&F show filter selection
  var $filter_labels = jQuery('.filter-labels');
  $filter_labels.empty();


  // remove items from the filter if you click on the labels
  $('.filter-labels').on('click', '.label', function () {
    var filterID = $(this).data('filter-id');
    var filterCategory = $(this).data('filter-category');
    var filterTitle = $(this).text();
    $('form.searchandfilter').find('select[name="' + filterID + '"]').prop("selectedIndex", 0);

    //remove depended labels
    if (filterCategory == '_sf_post_type') {
      if (filterTitle == 'Projecten') {
        $('.filter-labels .label').each(function () {
          var filterCategory = $(this).data('filter-category');
          if (filterCategory == '_sfm_tabel_jaar' || filterCategory == '_sfm_regelingen') {
            var filterID = $(this).data('filter-id');
            $('form.searchandfilter').find('input[name="' + filterID + '"]').prop("checked", false);
          }
        });
      } else if (filterTitle == 'Regelingen') {
        $('.filter-labels .label').each(function () {
          var filterCategory = $(this).data('filter-category');
          if (filterCategory == '_sfm_domein') {
            var filterID = $(this).data('filter-id');
            $('form.searchandfilter').find('input[name="' + filterID + '"]').prop("checked", false);
          }
        });
      }
    }

    $('form.searchandfilter').trigger('submit');
  });

  //add labels

  $('form.searchandfilter > ul').find('> li').each(function () {
    var filterCategory = $(this).attr('data-sf-field-name');

    $(this).find('.sf-option-active').each(function () {

      if ($(this).text().toLowerCase().indexOf("alle") == -1) {
        var filterID = $(this).parent().attr('name');
        var filterTitle = $(this).text();

        var $new_button = $('<div class="label" data-filter-id="' + filterID + '" data-filter-category="' + filterCategory + '">' + filterTitle + '</div>');
        $filter_labels.append($new_button);

      }
    });
  });


  //zoeken exception - only show options after submit
  if ($('.search-form-wrapper.zoeken form.searchandfilter > ul > li').length) {
    $('.search-form-wrapper.zoeken form.searchandfilter > ul > li').each(function () {
      if (!$('input[name="_sf_search[]"]').val()) {
        //no results, no options
        if ($(this).hasClass('sf-field-search') || $(this).hasClass('sf-field-submit')) {
          $(this).show();
        } else {
          $(this).hide();
        }
      }
    });
  }

  if ($('.js-search-collapse').length) {
    $('.js-search-collapse').each(function () {
      var $current_search = $(this);
      var $first_listitem = $current_search.find('form.searchandfilter > ul > li:first-child');
      $first_listitem.after('<li class="sf-field-collapse"><a href="#" class="collapse-link">Filters</a></li>');
    });

    $('.sf-field-collapse a').on('click', function (e) {
      e.preventDefault();
      $(this).parents('form.searchandfilter').toggleClass('show-all');

      //expanding/collapsing the filter list changes the sidebar height,
      //which the sticky-sidebar bottom check depends on
      if (typeof makestickySidebar === 'function') {
        makestickySidebar();
        setTimeout(makestickySidebar, 250); //again after the 0.2s height transition finishes
      }
    });
  }


  $('#mc-popup .close').on('click', function (e) {
    $(this).parents('#mc-popup').removeClass('active');
    $(this).parents('#mc-popup').addClass('deactivated');

    Cookies.set('hide_mc_popup', true, { expires: 7, path: '/' })
  });

  $("#mc-popup *").focusin(function () {
    $("#mc-popup").addClass('active');
  });

  $("#mc-popup *").focusout(function () {
    $("#mc-popup").removeClass('active');
  });

  $(window).scroll(function (event) {

    if ($('#mc-popup').length && !Cookies.get('hide_mc_popup')) {
      var scrollPos = $(window).scrollTop();
      var docHeight = $(document).height();

      if (scrollPos > (docHeight * 0.333)) {
        if (!$('#mc-popup').hasClass('deactivated')) {
          $('#mc-popup').addClass('active');
        }
      }
    }
  });

  $('.searchform-wrapper #searchsubmit').on('click', function (e) {
    //open form instead of submit
    var formselector = $(this).parents('#searchform');
    if (!formselector.hasClass('show')) {
      e.preventDefault();
      formselector.addClass('show');
      formselector.find('input.field').focus();
      $(this).attr('aria-expanded', 'true');
    } else if (!formselector.find('input.field').val()) {
      e.preventDefault();
    }
  });

  $('.searchform-wrapper #searchform .close-btn').on('click', function (e) {
    $(this).parents('#searchform').removeClass('show');
    $('.searchform-wrapper #searchsubmit').attr('aria-expanded', 'false');
    $('.searchform-wrapper #searchsubmit').focus();
  });


  //add button to confirmation questionnaire
  jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
    if ($('.block-questionnaire-form').length) {
      if ($('.gform_confirmation_wrapper').length) {
        $('.gform_confirmation_wrapper').append('<a class="btn reset" href="' + window.location.href + '">Reset</a>');
      }
    }
  });

  $('form.searchandfilter .sf-field-post-meta-regelingen select option').each(function () {
    var text = $(this).text();
    if (text.length > 30) {
      $(this).text(text.substring(0, 40) + '...');
    }
  });


  if ($(".js-timeline").length) {

    $(".js-timeline .timeline-item").on("click", function (e) {

      // Let links inside the content work normally — don't toggle or prevent default
      if ($(e.target).closest("a").length) {
        return;
      }
      e.preventDefault();
      $(this).toggleClass("active");

    });

  }

});


jQuery(document).on('keyup', function (evt) {
  if (jQuery('#mc-popup').hasClass('active')) {
    if (evt.keyCode == 27) {
      jQuery('#mc-popup .close').trigger('click');
    }
  }
});

jQuery(window).on('scroll', function () {
  progressBar();
});

function progressBar() {
  var winScroll = jQuery(window).scrollTop();
  var height = jQuery(document).height() - jQuery(window).height();
  var scrolled = ((winScroll / height) * 100).toFixed(2);
  jQuery("#progress-bar").css("width", scrolled + "%");
  jQuery("#progress-bar .value").text(scrolled + "%");
}



// Detect focus and closes mobile menu if focus is outside of menu
var navbarMobile = document.getElementById('navbarMobile');
var pageWrapper = document.getElementById('content');
var navbarCloseBtn = document.querySelector('.navbar-header .sec-navbar .close-btn');

pageWrapper.addEventListener('focusin', function (e) {

  if (navbarMobile.classList.contains('show')) {
    let current = document.activeElement;
    // detect if focus is of activeElement is in pageWrapper and if navbarMobile is open
    if (pageWrapper.contains(current)) {
      // trigger click on close button
      navbarCloseBtn.click();
    }
  }
})

function repositionSidenotes() {
  jQuery('.js-article-content a[href^="#"]').each(function () {
    var anchorId = jQuery(this).attr('href');
    var linkY = jQuery(this).position().top;

    jQuery(anchorId).css('top', linkY);
  });
}